import { Component, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { EventBusService, Events } from '../../../../technical-modules/events/services/event-bus.service';
import { UserService } from '../../../humain/user/services/user.service';

@Component({
	selector: 'btn-edit-acces-conduite',
	templateUrl: 'btn-edit-acces-conduite.html'	,
	styleUrls: ['btn-edit-acces-conduite.css']
})
export class ButtonEditAccesConduiteComponent {
	
	isUserCc$ = new BehaviorSubject<boolean>(false);
	
	constructor(@Inject(EventBusService) private eventBusService: EventBusService,
		@Inject(UserService) private userService: UserService) {
		
		// on interroge le serveur pour savoir si le user connecté est habilité CC ou pas 
		this.userService.getCurrentUserTLR().subscribe(
			(user) => {
				this.userService.isUserCcOnAtLeastOneOuvrage(user.id).subscribe(
					(isCc) => this.isUserCc$.next(isCc)
				);
			}
		);
	}
	
	editAccesConduite() {
		this.eventBusService.emit(Events.CreateAccesConduiteModalRequested, null);
	}
	
}